import { render } from "./DoornikKikirpa.vue?vue&type=template&id=5f0de4f5&scoped=true"
import script from "./DoornikKikirpa.vue?vue&type=script&lang=js"
export * from "./DoornikKikirpa.vue?vue&type=script&lang=js"

import "./DoornikKikirpa.vue?vue&type=style&index=0&id=5f0de4f5&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0de4f5"]])

export default __exports__